import { render } from "./ExerciseFabricComponent.vue?vue&type=template&id=4e5a75c8"
import script from "./ExerciseFabricComponent.vue?vue&type=script&lang=js"
export * from "./ExerciseFabricComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__